import type { ReactNode } from 'react';
import {
	AlertDialog,
	AlertDialogAction,
	AlertDialogCancel,
	AlertDialogContent,
	AlertDialogDescription,
	AlertDialogFooter,
	AlertDialogHeader,
	AlertDialogTitle
} from '@/components/ui/alert-dialog';

interface ConfirmDialogProps {
	open: boolean;
	title: string;
	children: ReactNode;
	confirmLabel: string;
	cancelLabel?: string;
	onConfirm: () => void;
	/** Cancel or Escape: the dialog closes and nothing happens. */
	onCancel: () => void;
}

/** Asks before an action. Confirming leaves closing to the caller, so it is never also read as a cancel. */
export const ConfirmDialog = ({ open, title, children, confirmLabel, cancelLabel = 'Cancel', onConfirm, onCancel }: ConfirmDialogProps) => (
	<AlertDialog open={open} onOpenChange={(next) => !next && onCancel()}>
		<AlertDialogContent>
			<AlertDialogHeader>
				<AlertDialogTitle>{title}</AlertDialogTitle>
				<AlertDialogDescription>{children}</AlertDialogDescription>
			</AlertDialogHeader>
			<AlertDialogFooter>
				<AlertDialogCancel>{cancelLabel}</AlertDialogCancel>
				<AlertDialogAction
					onClick={(event) => {
						event.preventDefault();
						onConfirm();
					}}
				>
					{confirmLabel}
				</AlertDialogAction>
			</AlertDialogFooter>
		</AlertDialogContent>
	</AlertDialog>
);
